module.exports = __webpack_public_path__ + "static/media/play-base-logo.e6c38ddc.svg";